import "../../utils/tailwind.css";
import { PageProvider, useBlogsProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";
import Plus from "../../components/svg/plus";
import Trash from "../../components/svg/trash";
import Pencil from "../../components/svg/pencil";
import ImageUploader from "../../components/upload-image";
import Input, { FormikInput } from "../../components/input";
import TableLoader from "../../components/table-loader";
import { Formik, Form } from "formik";
import { Accordion } from "react-bootstrap";
import Button from "../../components/Buttons";
import { FormikTextarea } from "../../components/textarea";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const {
    getBlogsQuery,
    handleEditClick,
    handleWorkDelete,
    handleAddBlogClick,
    handleOnChange,
    initialValues,
    handleSubmit,
    showDeleteModal,
    handleConfirmDelete,
    handleCancelDelete,
  } = useBlogsProvider();

  if (getBlogsQuery?.isPending) {
    return <TableLoader />;
  }

  return (
    <Section>
      <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0" className="mt-5">

              <Accordion.Item eventKey="1">
                <Accordion.Header>SEO Meta</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Meta Title" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_title" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Meta Keywords" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_keyword" rootClassName="w-full" as="textarea" className="h-[26rem]" />
                    </div>
                    <div className="flex flex-col ">
                      <Label label="Meta Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_desc" rootClassName="w-full" as="textarea" className="h-[26rem]" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>Banner</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_heading" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="SubHeading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_heading" rootClassName="w-full" />
                    </div>
                  </div>

                  <div className="grid grid-cols-4 gap-3 mt-3">
                    <div className="flex flex-col">
                      <Label label="CTA" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_cta.label" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="CTA Redirect Link" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_cta.redirect_link" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="CTA" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_cta.label" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="CTA Redirect Link" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_cta.redirect_link" rootClassName="w-full" />
                    </div>
                  </div>

                  <div className="mt-3">
                    <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                    <FormikTextarea name="header.description" rootClassName="w-full" />
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>Blogs</Accordion.Header>
                <Accordion.Body>

                  <div className="flex items-center justify-between gap-4">
                    <Input onChange={handleOnChange} placeholder="Search Blog" className="flex-1" />
                    <div className="bg-black p-1 rounded-full cursor-pointer" onClick={handleAddBlogClick}>
                      <Plus className="text-white" />
                    </div>
                  </div>

                  <div className="mt-3 overflow-x-auto mb-10">
                    <table className="w-full border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="border px-4 py-2 text-left">Blog Heading</th>
                          <th className="border px-4 py-2 text-left">Keywords</th>
                          <th className="border px-4 py-2 text-left w-[160px]">Banner Image</th>
                          <th className="border px-4 py-2 text-left w-[70px]">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {getBlogsQuery?.data?.data?.data?.map((item, index) => (
                          <tr key={index}>
                            <td className="border px-2 py-2">
                              <Label label={item.heading} />
                            </td>
                            <td className="border px-4 py-2">
                              <Label label={item.keywords} />
                            </td>
                            <td className="border px-4 py-2 text-center">
                              <BlogImage fileKey={item.banner_image} />
                            </td>
                            <td className="flex justify-between border py-[32px]">
                              <Pencil className="ml-4 cursor-pointer" onClick={() => handleEditClick(item)} />
                              <Trash className="mr-4 cursor-pointer" onClick={() => handleWorkDelete(item)} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 pr-4 shadow-md">
              <Button type="submit" className="!bg-[#7C13CA] text-white">
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>

      {showDeleteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[9999]">
          <div className="bg-white rounded-lg p-5 w-[300px] text-center">
            <p className="text-lg font-semibold mb-4">
              Are you sure you want to delete?
            </p>

            <div className="flex justify-center gap-4">
              <button
                onClick={handleConfirmDelete}
                className="bg-red-500 text-white px-4 py-2 rounded"
              >
                Yes
              </button>
              <button
                onClick={handleCancelDelete}
                className="bg-gray-300 px-4 py-2 rounded"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </Section>
  );
}

const BlogImage = ({ fileKey }) => {
  return <ImageUploader imgStyle={{ width: "6rem" }} imageUrl={fileKey || ""} />;
};